<div class="access-denied-page">
  <nav class="brand-bar">
    <img src="assets/images/logo.svg" alt="Application logo">
  </nav>

  <div class="access-denied-content">
    <div class="icon-container">
      <i class="bi bi-lock"></i>
    </div>

    <h2>Access Denied</h2>
    <div class="divider"></div>

    <p>You don't have permission to access this application.</p>
    <p class="text-secondary">Contact your administrator if you believe this is an error.</p>

    <button class="btn btn-primary btn-logout" (click)="logout()">Logout</button>
  </div>
</div>
